import React from 'react'

export default ({ ...props }) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle id='modal-arrow-circle' cx='16' cy='16' r='9.5' stroke='#B7B7B7' {...props} />
    <path
      id='modal-arrow-path'
      d='M14.5003 11.001C14.3723 11.001 14.2443 11.05 14.1463 11.147C13.9513 11.342 13.9513 11.659 14.1463 11.854L18.7923 16.5L14.1463 21.146C13.9513 21.341 13.9513 21.658 14.1463 21.853C14.3413 22.048 14.6583 22.048 14.8533 21.853L19.8533 16.853C20.0483 16.658 20.0483 16.341 19.8533 16.146L14.8533 11.146C14.7553 11.048 14.6273 11 14.4993 11L14.5003 11.001Z'
    />
  </svg>
)
